import React from "react";
import { api, API } from "@/lib/api";
import { PageHeader, Card } from "@/components/Shell";
import { FileSpreadsheet, Download } from "lucide-react";

const REPORTS = [
  { key: "stock", name: "Current Stock Report", desc: "All buckets with quantity, min stock & value." },
  { key: "requests", name: "Material Requests Report", desc: "Requests with requester, approver(s), line costs, usage location." },
  { key: "issues", name: "Issue Report", desc: "Material issued to engineers with serials." },
  { key: "projects", name: "Project / Circuit Report", desc: "Serialized + non-serialized material per project." },
  { key: "project-cost", name: "Project Cost Report", desc: "Per-project material cost rollup." },
  { key: "recoveries", name: "Recovery Report", desc: "All recoveries with condition & serials." },
  { key: "dispatches", name: "Dispatch / E-way Bill Report", desc: "All dispatches with tracking & e-way bill." },
  { key: "audit", name: "Audit Log Report", desc: "All system actions, admin only." },
];

export default function Reports() {
  const download = async (key) => {
    const res = await api.get(`/reports/${key}`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${key}_report.xlsx`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
  };

  return (
    <div className="p-4 md:p-8" data-testid="reports-page">
      <PageHeader title="Reports" subtitle="Excel-exportable reports across the portal." />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {REPORTS.map(r => (
          <Card key={r.key} className="p-5">
            <div className="flex items-start justify-between mb-2">
              <FileSpreadsheet className="text-[#F97316]" size={22} />
            </div>
            <div className="font-display font-semibold text-base">{r.name}</div>
            <div className="text-xs text-zinc-500 mt-1 mb-4">{r.desc}</div>
            <button
              data-testid={`report-${r.key}`}
              onClick={()=>download(r.key)}
              className="inline-flex items-center gap-2 text-xs font-semibold bg-[#18181B] hover:bg-[#27272A] text-white py-2 px-3 rounded-md"
            >
              <Download size={13} /> Export Excel
            </button>
          </Card>
        ))}
      </div>
    </div>
  );
}
